<template>
<div class="chapter">
<div class="inner_page">
<h2 class="pn"><a id="page_1"></a><a id="page_2"></a>P<span class="small">ART</span> I</h2>
<h2 class="pt"><em class="italic">The Tortures of Cuenca</em></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Part1.vue?4610d6b8